module.exports = __webpack_public_path__ + "img/ins.a693a499.svg";